import {
	TravelReport,
	TravelReportType,
	TravelExpenseReport,
	TravelExpenseSettings,
	ExpenseFeatureSettings,
	TravelPerDiem,
	DriverLog,
	DriverLogItem,
} from '../Types/admin/timereport';
import {
	CreateTravelReportRequest,
	UpdateTravelReportRequest,
	CreateDriverLogRequest,
	CreateDriverLogItemRequest,
	UpdateDriverLogRequest,
	UpdateDriverLogItemRequest,
} from '../Types/timereport';
import { get, getQSFromObject, httpDelete, post } from './common';

const endpoint = 'api/travelreport';

// Travel Reports
export const getTravelReports = (start: string, end: string) =>
	get<TravelReport[]>(`${endpoint}/GetTravelReports?${getQSFromObject({ start, end })}`);

export const getTravelReport = (id: number) => get<TravelReport>(`${endpoint}/GetTravelReport?${getQSFromObject({ id })}`);

export const createTravelReport = (data: CreateTravelReportRequest) => post<TravelReport>(`${endpoint}/CreateTravelReport`, data);

export const updateTravelReport = (data: UpdateTravelReportRequest) => post<TravelReport>(`${endpoint}/UpdateTravelReport`, data);

export const deleteTravelReport = (id: number) => httpDelete(`${endpoint}/DeleteTravelReport?${getQSFromObject({ id })}`);

export const submitTravelReport = (id: number) => post(`${endpoint}/SubmitTravelReport?${getQSFromObject({ id })}`, {});

// Travel Report Types
export const getTravelReportTypes = () => get<TravelReportType[]>(`${endpoint}/GetTravelReportTypes`);

// Travel Expense Settings
export const getTravelExpenseSettings = () => get<TravelExpenseSettings>(`${endpoint}/GetTravelExpenseSettings`);

export const getExpenseFeatureSettings = () => get<ExpenseFeatureSettings>(`${endpoint}/GetExpenseFeatureSettings`);

// Expense Reports
export const getExpenseReports = () => get<TravelExpenseReport[]>(`${endpoint}/GetExpenseReports`);

export const getExpenseReport = (id: number) =>
	get<TravelExpenseReport>(`${endpoint}/GetExpenseReport?${getQSFromObject({ id })}`);

export const createExpenseReport = (
	report: Omit<TravelExpenseReport, 'id' | 'portalId' | 'userId' | 'isSubmitted' | 'isAttested' | 'isDeleted'>
) => post<TravelExpenseReport>(`${endpoint}/CreateExpenseReport`, report);

export const updateExpenseReport = (report: TravelExpenseReport) =>
	post<TravelExpenseReport>(`${endpoint}/UpdateExpenseReport`, report);

export const deleteExpenseReport = (id: number) => httpDelete(`${endpoint}/DeleteExpenseReport?${getQSFromObject({ id })}`);

// Per-Diem
export const getPerDiems = (expenseReportId: number) =>
	get<TravelPerDiem[]>(`${endpoint}/GetPerDiems?${getQSFromObject({ expenseReportId })}`);

export const createPerDiem = (perDiem: Omit<TravelPerDiem, 'id' | 'portalId' | 'isDeleted'>) =>
	post<{ id: number }>(`${endpoint}/CreatePerDiem`, perDiem);

// Driver Logs
export const getDriverLogs = () => get<DriverLog[]>(`${endpoint}/GetDriverLogs`);

export const getDriverLog = (id: number) => get<DriverLog>(`${endpoint}/GetDriverLog?${getQSFromObject({ id })}`);

export const createDriverLog = (data: CreateDriverLogRequest) => post<DriverLog>(`${endpoint}/CreateDriverLog`, data);

export const updateDriverLog = (data: UpdateDriverLogRequest) => post<DriverLog>(`${endpoint}/UpdateDriverLog`, data);

export const deleteDriverLog = (id: number) => httpDelete(`${endpoint}/DeleteDriverLog?${getQSFromObject({ id })}`);

export const submitDriverLog = (id: number) => post(`${endpoint}/SubmitDriverLog?${getQSFromObject({ id })}`, {});

export const getDriverLogItems = (driverLogId: number) =>
	get<DriverLogItem[]>(`${endpoint}/GetDriverLogItems?${getQSFromObject({ driverLogId })}`);

export const createDriverLogItem = (data: CreateDriverLogItemRequest) =>
	post<{ id: number }>(`${endpoint}/CreateDriverLogItem`, data);

export const updateDriverLogItem = (data: UpdateDriverLogItemRequest) => post(`${endpoint}/UpdateDriverLogItem`, data);

export const deleteDriverLogItem = (id: number) => httpDelete(`${endpoint}/DeleteDriverLogItem?${getQSFromObject({ id })}`);
